// ── Importaciones tal cual ──────────────────────────────
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ErrorAlert from '../../Alerts/ErrorAlert';
import SuccessAlert from '../../Alerts/SuccessAlert';
import { MachinesFetchAPI } from '../../../api/Machines';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .msm-
───────────────────────────────────────────────────────── */
const MSM_CSS = `
@keyframes msm-slide { from{opacity:0;transform:translateY(14px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }
@keyframes msm-up    { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

/* ── modal ── */
.msm-dialog { max-width: 560px !important; }
.msm-dialog .modal-content {
  border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 24px 64px rgba(0,0,0,.18), 0 6px 16px rgba(0,0,0,.08) !important;
  overflow: hidden !important;
  animation: msm-slide .28s cubic-bezier(.34,1.56,.64,1) both !important;
}
.msm-dialog .modal-header { display: none !important; }
.msm-dialog .modal-body   { padding: 0 !important; }
.msm-dialog .modal-footer { display: none !important; }

/* ── header ── */
.msm-head {
  display: flex; align-items: center; gap: .65rem;
  padding: 1rem 1.25rem .9rem;
  background: linear-gradient(135deg, #0F2444 0%, #1B3A6B 100%);
}
.msm-head-ico {
  width: 38px; height: 38px; border-radius: 50%; flex-shrink: 0;
  background: rgba(255,255,255,.12); color: #fff;
  display: grid; place-items: center;
}
.msm-head-info { flex: 1; }
.msm-head-title {
  font-size: .95rem; font-weight: 700; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.msm-head-sub {
  font-size: .71rem; color: rgba(255,255,255,.55); margin-top: 1px;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.msm-close {
  width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
  border: 1.5px solid rgba(255,255,255,.2);
  background: rgba(255,255,255,.1); color: rgba(255,255,255,.8);
  display: grid; place-items: center; cursor: pointer; transition: all .14s;
}
.msm-close:hover { background: rgba(239,68,68,.3); border-color: rgba(239,68,68,.5); color: #fff; }

/* ── body ── */
.msm-body { padding: 1.1rem 1.25rem; }

/* ── hint ── */
.msm-hint {
  display: flex; align-items: flex-start; gap: .45rem;
  padding: .65rem .9rem; border-radius: 10px; margin-bottom: 1rem;
  background: rgba(27,58,107,.06); border: 1px solid rgba(27,58,107,.14);
  font-size: .76rem; color: #1B3A6B; line-height: 1.6;
  font-family: var(--font-sans,-apple-system,sans-serif);
}

/* ── integrations grid ── */
.msm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: .75rem;
}

/* ── integration card ── */
.msm-card {
  display: flex; flex-direction: column; gap: .65rem;
  padding: .9rem 1rem; border-radius: 14px;
  border: 1.5px solid rgba(0,0,0,.08);
  background: var(--bg, #fff);
  box-shadow: 0 2px 8px rgba(0,0,0,.05);
  animation: msm-up .22s ease both;
  transition: border-color .14s, box-shadow .14s;
}
.msm-card:hover { border-color: rgba(27,58,107,.25); box-shadow: 0 4px 14px rgba(0,0,0,.08); }

.msm-card-ico {
  width: 38px; height: 38px; border-radius: 10px;
  background: rgba(27,58,107,.08); color: #1B3A6B;
  display: grid; place-items: center;
}
.msm-card-name {
  font-size: .85rem; font-weight: 700; color: var(--text, #0A0A0A);
  font-family: var(--font-sans,-apple-system,sans-serif); line-height: 1.3;
}
.msm-btn-settle {
  display: inline-flex; align-items: center; gap: .35rem;
  width: 100%; justify-content: center;
  padding: .52rem .85rem; border-radius: 9px; border: none;
  background: #1B3A6B; color: #fff;
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .78rem; font-weight: 600;
  cursor: pointer; transition: background .14s, transform .14s;
}
.msm-btn-settle:hover { background: #152D54; transform: translateY(-1px); }

/* ── empty state ── */
.msm-empty {
  display: flex; flex-direction: column; align-items: center;
  padding: 2.5rem 1rem; gap: .6rem; text-align: center;
}
.msm-empty-icon {
  width: 52px; height: 52px; border-radius: 50%;
  background: rgba(0,0,0,.04); color: #9CA3AF;
  display: grid; place-items: center;
}
.msm-empty-title { font-size: .85rem; font-weight: 700; color: #6B7280; font-family: var(--font-sans,-apple-system,sans-serif); }
.msm-empty-sub   { font-size: .75rem; color: #9CA3AF; font-family: var(--font-sans,-apple-system,sans-serif); }

/* ── footer ── */
.msm-footer {
  display: flex; justify-content: flex-end;
  padding: .75rem 1.25rem .9rem;
  border-top: 1px solid var(--border, rgba(0,0,0,.07));
}
.msm-btn-close {
  display: inline-flex; align-items: center; gap: .35rem;
  padding: .5rem 1.1rem; border-radius: 9px;
  border: 1.5px solid rgba(0,0,0,.12); background: rgba(0,0,0,.04);
  color: var(--text-2, #6B6B6B);
  font-family: var(--font-sans,-apple-system,sans-serif);
  font-size: .81rem; font-weight: 500; cursor: pointer; transition: all .13s;
}
.msm-btn-close:hover { border-color: #1B3A6B; color: #1B3A6B; }

@media(max-width: 480px) {
  .msm-dialog { max-width: calc(100vw - 1.5rem) !important; }
  .msm-grid   { grid-template-columns: 1fr 1fr; }
}
@media(max-width: 360px) {
  .msm-grid { grid-template-columns: 1fr; }
}
`;

/* ── ICONS ── */
const IcoPower = ()=><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>;
const IcoCrd   = ()=><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IcoCheck = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoX     = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoInfo  = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const ModalSettleMachine = ({
  machine_id, machine_code, selectedBranch,
  showModal, setShowModal, setEventHandler, eventHandler, token
}) => {

  useEffect(() => {
    const id = "msm-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = MSM_CSS;
      document.head.appendChild(el);
    }
  }, []);

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [paymentMethodIntegrations, setPaymentMethodIntegrations] = useState([]);

  const makeSettle = async (paymentmethod_integration_id) => {
    try {
      const res = await MachinesFetchAPI.settleMachine(machine_code, selectedBranch.code, paymentmethod_integration_id, token);
      SuccessAlert(res.data.message);
    } catch (err) {
      ErrorAlert("Error al realizar el cierre de la maquina", "Error", "error");
    }
  };

  const getMachinePaymentMethodIntegrations = async () => {
    try {
      const paymentMethodIntegrations = await MachinesFetchAPI.getMachinePaymentMethodIntegrations(machine_id, token);
      setPaymentMethodIntegrations(paymentMethodIntegrations.data.integrations);
    } catch (err) { setPaymentMethodIntegrations([]); }
  };

  const paymentMethodIntegrationsList = () => {
    const listPaymentMethodIntegrations = paymentMethodIntegrations.map((integration) => (
      <div key={integration.id} className="col-12-col-md-2 col-lg-4 mt-2">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">{integration.name}</h5>
            <button className="btn btn-primary" onClick={() => makeSettle(integration.id)}>Realizar cierre</button>
          </div>
        </div>
      </div>
    ));
    return listPaymentMethodIntegrations;
  };

  useEffect(() => {
    getMachinePaymentMethodIntegrations();
    setEventHandler(0);
  }, [eventHandler]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      <Modal
        show={showModal}
        onBackdropClick={() => setShowModal(false)}
        size="lg"
        centered
        dialogClassName="msm-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>Realizar cierre</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          {/* ── header visual navy ── */}
          <div className="msm-head">
            <div className="msm-head-ico"><IcoPower /></div>
            <div className="msm-head-info">
              <div className="msm-head-title">Realizar cierre de máquina</div>
              <div className="msm-head-sub">
                Máquina <strong style={{ color: '#fff' }}>{machine_code}</strong> · {selectedBranch?.name || selectedBranch?.code || ''}
              </div>
            </div>
            <button className="msm-close" type="button" onClick={() => setShowModal(false)}>
              <IcoX />
            </button>
          </div>

          <div className="msm-body">

            {/* hint */}
            <div className="msm-hint">
              <IcoInfo />
              Selecciona una integración para realizar el cierre de caja. Esta acción procesará las transacciones pendientes.
            </div>

            {/* integrations grid */}
            {paymentMethodIntegrations.length > 0 ? (
              <div className="msm-grid">
                {paymentMethodIntegrations.map((integration, i) => (
                  <div
                    className="msm-card"
                    key={integration.id}
                    style={{ animationDelay: `${i * 0.07}s` }}
                  >
                    <div className="msm-card-ico"><IcoCrd /></div>
                    <div className="msm-card-name">{integration.name}</div>
                    {/* makeSettle — lógica original intacta */}
                    <button
                      className="msm-btn-settle btn btn-primary"
                      onClick={() => makeSettle(integration.id)}
                    >
                      <IcoCheck /> Realizar cierre
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="msm-empty">
                <div className="msm-empty-icon"><IcoCrd /></div>
                <p className="msm-empty-title">Sin integraciones disponibles</p>
                <p className="msm-empty-sub">Esta máquina no tiene métodos de pago configurados.</p>
              </div>
            )}

          </div>

          {/* footer */}
          <div className="msm-footer">
            <button className="msm-btn-close" type="button" onClick={() => setShowModal(false)}>
              Cerrar
            </button>
          </div>

        </Modal.Body>

        {/* Modal.Footer original — lógica intacta */}
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* imports no-JSX preservados */}
      {void [ErrorAlert, SuccessAlert]}
    </>
  );
};

export default ModalSettleMachine;